<template>
  <section id="setup" class="container"  :class="{'content-select': step === 3}">
    <section
      v-if="step === 1"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h1>Obrigado pelo cadastro, vamos te dar Controle da sua OPERAÇÃO!</h1>
        <p class="margin-top-m">
          Vamos precisar que você siga este fluxo para coletar algumas informações e otimizar em muito sua experiência na Único Tracker!
        </p>
      </div>
      <div class="flex column middle center margin-top-l">
        <form>
          <!-- Modelo da Operação -->
          <div class="flex-1 w100">
            <label>
              Qual modelo da sua operação?
            </label>
            <div class="flex flex-1 big-select center row margin-top-l">
              <div 
                @click="firstType('DROPSHIPPING')"
                class="button primary option"
                :class="{ active: info.operation === 'DROPSHIPPING' }"
              >
                <b>DROPSHIPPING</b>
              </div>
              <div
                @click="firstType('INFOPRODUTO')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'INFOPRODUTO' }"
              >
                <b>INFOPRODUTO</b>
              </div>
              <div
                @click="firstType('PLR')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'PLR' }"
              >
                <b>PLR</b>
              </div>
              <div
                @click="firstType('E-COMMERCE')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'E-COMMERCE' }"
              >
                <b>E-COMMERCE</b>
              </div>
            </div>
            <div class="flex flex-1  big-select row center margin-top-s">
              <div
                @click="firstType('SAAS')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'SAAS' }"
              >
                <b>SAAS</b>
              </div>
              <div
                @click="firstType('LANÇAMENTO')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'LANÇAMENTO' }"
              >
                <b>LANÇAMENTO</b>
              </div>
              <div
                @click="firstType('OUTROS')"
                class="button primary option"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'OUTROS' }"
              >
                <b>OUTROS</b>
              </div>
            </div>
          </div>

          <!-- Investimento em MKT -->
          <div class="flex-1 margin-top-l w100">
            <label>Qual Seu WhatsApp?</label>
            <the-mask
              :mask="['(##) ####-####', '(##) #####-####']"
              v-model="info.phone"
              class="input"
            />
          </div>
          
          <!-- Investimento em MKT -->
          <div class="flex-1 margin-top-l w100">
            <label>Valor gasto mensal em Tráfego Pago?</label>
            <money v-model="info.marketing" v-bind="money"></money>
          </div>
          
          <!-- Faturamento Mensal -->
          <div class="flex-1 margin-top-l w100">
            <label>Faturamento da sua operação mensal?</label>
            <money v-model="info.faturamento" v-bind="money"></money>
          </div>
        </form>
      </div>
      <div class="buttons flex center">
        <button class="button primary medium" @click="checkStep()">
          Apenas mais 1 passo
        </button>
      </div>
    </section>

    <section
      v-if="step === 2"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <p>
          Precisamos saber apenas mais algumas informações.
        </p>
      </div>
      <div class="flex column middle center margin-top-l">

        <!-- Tempo operação -->
        <div class="flex-1 w100">
          <label>
            Quanto tempo tem sua operação?
          </label>
          <div class="flex row big-select  w100 margin-top-l">
            <div 
              @click="secondaryType('0-1 mês')"
              class="button primary flex-1 option"
              :class="{ active: info.time === '0-1 mês' }"
            >
              <b>0-1 mês</b>
            </div>
            <div
              @click="secondaryType('1-6 meses')"
              class="button primary flex-1 option" 
              style="margin-left: 10px"
              :class="{ active: info.time === '1-6 meses' }"
            >
              <b>1-6 meses</b>
            </div>
            <div
              @click="secondaryType('6-12 meses')"
              class="button primary flex-1 option"
              style="margin-left: 10px"
              :class="{ active: info.time === '6-12 meses' }"
            >
              <b>6-12 meses</b>
            </div>
            <div
              @click="secondaryType('12-24 meses')"
              class="button primary flex-1 option"
              style="margin-left: 10px"
              :class="{ active: info.time === '12-24 meses' }"
            >
              <b>12-24 meses</b>
            </div>
            <div
              @click="secondaryType('24+ meses')"
              class="button primary flex-1 option"
              style="margin-left: 10px"
              :class="{ active: info.time === '24+ meses' }"
            >
              <b>24+ meses</b>
            </div>
            
          </div>
        </div>

        <!-- Origem -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>Onde conheceu a ferramenta?</label>
              <input class="input" type="text" v-model="info.source" />
          </div>
        </div>

        <!-- Dificuldade -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>Qual sua maior dificuldade hoje?</label>
              <input class="input" type="text" v-model="info.dificuldade" />
          </div>
        </div>
        
        <!-- O que espera -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>O que espera em relação a ÚnicoTracker?</label>
              <input class="input" type="text" v-model="info.lucreihoje" />
          </div>
        </div>
      </div>
      <div class="buttons flex center">
        <div class="flex center">
          <button class="button primary medium" @click="checkStep()">
            Acessar a Melhor Plataforma de Trackeamento!
          </button>
        </div>
      </div>
      <div v-if="false" class="buttons flex center">
        <button v-if="false" class="button secondary medium" @click="step--">
          Voltar
        </button>
        <button class="button primary medium" style="margin-left:16px" @click="updateAccount()">
          {{ account.choice_plan? "Finalizar Assinatura" : "Escolha seu Plano" }}
        </button>
        <button v-if="false" class="button primary medium" style="margin-left:16px" @click="updateAccountFreemium()">
          Iniciar Teste de 14 dias
        </button>
      </div>
    </section>

    <section
      v-if="step === 4"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h2>
          Atenção: você precisa ver o vídeo abaixo antes de continuar!
        </h2>
      </div>
      <div class="flex column middle center margin-top-l">
          <iframe width="100%" height="360" src="https://www.youtube.com/embed/e2v0AOsaS_E?si=MLBtKFq4-J8nkSTw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      <div class="buttons flex center">
        <button v-if="false" class="button secondary medium" @click="step--">
          Voltar
        </button>
        <button class="button primary medium" @click="checkStep()">
          Acessar a Melhor Plataforma de Trackeamento!
        </button>
        <button v-if="false" class="button primary medium" style="margin-left:16px" @click="updateAccount()">
          {{ account.choice_plan? "Finalizar Assinatura" : "ESCOLHER SEU PLANO E OTIMIZE SUAS CAMPANHAS" }}
        </button>
        <button v-if="false" class="button primary medium" style="margin-left:16px" @click="updateAccountFreemium()">
          Iniciar Teste de 14 dias
        </button>
      </div>
    </section>


    <section
      v-if="step === 3"
      id="setup-content"
      class="install step1 selectplan"
    >
      <div class="flex w100 center title">
        <h1 class="txt-center" style="max-width: 720px;">
          Escolha como você quer começar sua jornada de TRACKEAMENTO com a ÚNICO!
        </h1>
      </div>
      <div class="grid margin-top-l row">
        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Essencial</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 20.000 / mês em vendas</li>
                  <li>1 conta de anúncio</li>
                  <li>1 dashboard</li>
                  <li>15 dias de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 49,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[0])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l no-mobile">
          <div class="box-title flex center middle">
              <h2>Profissional</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 100.000 / mês em vendas</li>
                  <li>5 conta de anúncio</li>
                  <li>3 dashboard</li>
                  <li>1 Whatsapp Trackeado</li>
                  <li>1 Domínio Trackeado</li>
                  <li>90 dias de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 147,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[1])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center">
              <h2>Completo</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 500.000 / mês em vendas</li>
                  <li>20 conta de anúncio</li>
                  <li>6 dashboard</li>
                  <li>2 Whatsapp Trackeado</li>
                  <li>2 Domínio Trackeado</li>
                  <li>12 meses de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 297,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[2])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Ilimitado</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 5.000.000 / mês em vendas</li>
                  <li>50 conta de anúncio</li>
                  <li>10 dashboard</li>
                  <li>5 Whatsapp Trackeado</li>
                  <li>10 Domínio Trackeado</li>
                  <li>Sem limite de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 497,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[3])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Para Agência</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Para até 10 clientes ou seja Você só paga R$ 59,70 por cliente (Profissional)</li>
                  <li>Uma conta individual para cada Cliente</li>
                  <li>Todos os recursos do plano Profissional!</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 597,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[4])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

      </div>

      <div v-if="false" class="buttons flex center margin-top-l">
        <button class="button secondary medium" @click="step--" style="margin-right: 8px;">
          Voltar
        </button>
        <button  class="button primary medium" @click="updateAccount()">
          Vamos Começar
        </button>
      </div>
    </section>

    <div v-if="loading" id="background-loader">
      <div class="loader" id="loader"></div>
      <div class="margin-top-l">
        <p>Carregando...</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { Money } from 'v-money'

import { Account, updateAccount } from "@/services/account";

export default {
  name: "SelectPlan",
  props: {
    msg: String,
  },
  components: {
    Money
  },
  data() {
    return {
      step: 1,
      loading: false,
      info: {
        phone: '',
        operation: '',
        time: '',
        marketing: 0,
        faturamento: 0,
        lucreihoje: '',
        source: '',
        dificuldade: '',
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      urlPlan: [
        "https://pay.kiwify.com.br/zc8ELdY", // essencial
        "https://pay.kiwify.com.br/k0MlC8p", // profissional
        "https://pay.kiwify.com.br/mJgDu3J", // completo
        "https://pay.kiwify.com.br/8xrQVDT", // ilimitado
        "https://pay.kiwify.com.br/Xd2uLpi" // agencia
      ],
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    checkStep() {

      if (!this.info.phone) {
        this.$toast.error({
          title:'Erro',
          message:'Preencha todos os dados para seguir'
        })
        return
      }
      this.step++
    },
    firstType(typeAccount) {
      this.info.operation = typeAccount;
    },
    secondaryType(secondaryInfo) {
      this.info.time = secondaryInfo;
    },
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    adjustUrl(url) {
      if (!this.account) {
        return
      }
      if (this.account.afiliate_kiwify_code) {
        return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}&afid=${this.account.afiliate_kiwify_code}`
      }
      return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}`
    },
    updateAccount(urlBase) {

      var url = this.adjustUrl(urlBase)

      this.loading = true

      let params = {
        phone: this.info.phone,
        business_type: this.info.operation,
        marketing: this.info.marketing,
        faturamento: this.info.faturamento,
        time_business: this.info.time,
        source: this.info.source,
        dificuldade: this.info.dificuldade,
        watch_await: this.info.lucreihoje,
      };

      updateAccount(params)
        .then(() => {
          if (url) {
            document.location.href = url
          } else {
            // freemium flow
            this.$router.push({ name: "Home" });
          }
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao salvar informações",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateAccountFreemium() {
      this.loading = true

      let params = {
        phone: this.info.phone,
        business_type: this.info.operation,
        marketing: this.info.marketing,
        faturamento: this.info.faturamento,
        time_business: this.info.time,
        source: this.info.source,
        dificuldade: this.info.dificuldade,
        watch_await: this.info.lucreihoje,
        freemium: true
      };

      updateAccount(params)
        .then(() => {
          this.$router.push({ name: "Home" });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao salvar informações",
          });
        })
        .finally(() => {
          this.loading = false
        })
      },
  },
};
</script>

<style lang="scss" scoped>
#setup {
  margin-top: 100px;
  label {
    font-weight: 800;
  }
}

.title {
  margin-bottom: 16px;
}

.button.primary  {
  &.active {
    background: #000;
  }
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid var(--primary);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

iframe {
  border-radius: 8px;
}

.content-select {
  max-width: 1200px !important;
}

.selectplan {

  .de-price {
    color: #666;
  }

  .promo {
    position: absolute;
    top: 20px;
    padding: 8px 16px;
    background: yellow;
    color: #000;
    border-radius: 4px;
    font-weight: 800;
  }

  .box {
    .box-content {
      position: relative;
      .content {
        min-height: 165px;
      }
      ul {
        margin-left: 14px;
        li {
          padding: 4px;
        }
      }

      .action {
        border-top: 1px solid #00000022;
      }
    }
    .box-title {
      padding: 4px 15px;
      h2 {
        font-size: 28px;
        font-weight: 800;
      }
    }
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

@media only screen and (max-width: 1024px) {
  .box {
    
    .box-content {
      position: relative;
      .content {
        min-height: 0px !important;
      }
    }
  }
  .big-select {
    .option {
      width: 100% !important;
      margin-left: 0px !important;
      margin-top: 4px;
    }
  }

  .container {
    padding: 0px !important;
  }
  .grid-flex .box + .box, .flex .box + .box {
    margin-left: 00px;
  }
}



</style>
